import { LegacyErrorResult, postJson } from "../ChoiceApi";

export async function importResultsHL7(hl7Data: string, dataType: ImportResultsHL7DataType = ImportResultsHL7DataType.Lab): Promise<LegacyErrorResult|undefined>
{
    return await postJson("/api/Order/Results/HL7", {
        hl7Data: hl7Data,
        dataType: dataType
    });
}

export enum ImportResultsHL7DataType
{
    Lab = 1,
    Spirometer = 2
}